import { render, staticRenderFns } from "./AuthorizedChannels.vue?vue&type=template&id=193276ec&scoped=true"
import script from "./AuthorizedChannels.vue?vue&type=script&lang=js"
export * from "./AuthorizedChannels.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedChannels.vue?vue&type=style&index=0&id=193276ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193276ec",
  null
  
)

export default component.exports